import { Component } from '@angular/core';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { AuthenticationService } from '../../../services/auth/authentication.service';

import * as jwt_decode from 'jwt-decode';
import { Router } from '@angular/router';
import { AccessRightManagement } from '../../../helpers/access-rights';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})

export class HeaderComponent {

  searchVisible: boolean = false;
  quickViewVisible: boolean = false;
  isFolded: boolean;
  isExpand: boolean;
  email: string = "";
  hasDevSettingsRight: boolean = false;

  constructor(
    private themeService: ThemeConstantService,
    private authenticationService: AuthenticationService,
    private route: Router,
    private access: AccessRightManagement
  ) {
    var jwt = localStorage.getItem('currentUser');
    var jwtDecoded = jwt_decode(jwt);

    this.email = jwtDecoded['sub'];

    this.hasDevSettingsRight = this.access.hasRight('permissions.devsettings.managekeys');
    // this.authenticationService.getUserDetails().subscribe(res => {
    //   console.log('triggered');
    //   console.log(res);
    // })
  }

  ngOnInit(): void {
    this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
    this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);
  }

  toggleFold() {
    this.isFolded = !this.isFolded;
    this.themeService.toggleFold(this.isFolded);
  }

  toggleExpand() {
    this.isFolded = false;
    this.isExpand = !this.isExpand;
    this.themeService.toggleExpand(this.isExpand);
    this.themeService.toggleFold(this.isFolded);
  }

  searchToggle(): void {
    this.searchVisible = !this.searchVisible;
  }

  quickViewToggle(): void {
    this.quickViewVisible = !this.quickViewVisible;
  }

  logout() {
    this.authenticationService.logout();
    location.reload();
    this.route.navigate(['/authentication/login'])
  }

  notificationList = [
    {
      title: 'You received a new message',
      time: '8 min',
      icon: 'mail',
      color: 'ant-avatar-' + 'blue'
    },
    {
      title: 'New user registered',
      time: '7 hours',
      icon: 'user-add',
      color: 'ant-avatar-' + 'cyan'
    },
    {
      title: 'System Alert',
      time: '8 hours',
      icon: 'warning',
      color: 'ant-avatar-' + 'red'
    },
    {
      title: 'You have a new update',
      time: '2 days',
      icon: 'sync',
      color: 'ant-avatar-' + 'gold'
    }
  ];
}
